

import React from 'react';
import { AddonsConsumer } from '../../../../Addons';
import CommonAddonViewComponent from '../components/CommonAddonView';

function CommonAddonView(props) {
  return (
    <AddonsConsumer>
      {({ actions: { getFormattedAddon } }) =>
      <CommonAddonViewComponent
        getFormattedAddon={getFormattedAddon}
        {...props} />}


    </AddonsConsumer>);

}

export default CommonAddonView;